//@ts-nocheck
import { ReactNode } from 'react';
import Meta from '@components/Meta';
import Header from '@components/Header';
import Landscape, { LandscapeVariants } from '@components/Landscape';
import Desktop from '@components/Desktop';
import Videomodal from '@components/ModalVideo/index';

type LayoutProps = {
  children: ReactNode;
  showBackButton?: boolean;
  showHeader?: boolean;
  showGMdesktop?: boolean;
  showBaileyDesktop?: boolean;
  showFashionDesktop?: boolean;
  showLogo?: boolean;
  showLogoBlog?: boolean;
  showLogoBlogMob?: boolean;
  showMenu?: boolean;
  color?: string;
  animationHeader?: string;
  logo?: any;
  email?: string;
  whatAppmsg?: string;
  whatAppLink?: string;
  hideError?: boolean;
  showNoheader?: boolean;
  showCopyheader?: boolean;
  showTheStoryHeader?: boolean;
};

const Layout = ({
  children,
  showBackButton,
  showHeader,
  showGMdesktop,
  showBaileyDesktop,
  showFashionDesktop,
  showLogo,
  showLogoBlog,
  showLogoBlogMob,
  showMenu,
  color,
  animationHeader,
  logo,
  email,
  whatAppmsg,
  whatAppLink,
  hideError,
  showNoheader,
  showCopyheader,
  showTheStoryHeader
}: LayoutProps) => {
  return (
    <Desktop
      showGMdesktop={showGMdesktop}
      showBaileyDesktop={showBaileyDesktop}
      showFashionDesktop={showFashionDesktop}
    >
      <Landscape variant={LandscapeVariants.WHITE} hideError={hideError}>
        <Meta />
        {showHeader && (
          <Header
            showBackButton={showBackButton}
            showLogo={showLogo}
            showLogoBlog={showLogoBlog}
            showLogoBlogMob={showLogoBlogMob}
            showMenu={showMenu}
            color={color}
            animationHeader={animationHeader}
            logo={logo}
            email={email}
            whatAppmsg={whatAppmsg}
            whatAppLink={whatAppLink}
            showNoheader={showNoheader}
            showCopyheader={showCopyheader}
            showTheStoryHeader={showTheStoryHeader}
          />
        )}
        {children}
      </Landscape>
    </Desktop>
  );
};

export default Layout;
